import React, { useState, useRef } from 'react';
import styles from './StatusDropdown.module.scss';
import Icon from '../Icon/Icon';
import useClickOutside from '../../CustomHooks/useClickOutside';

interface StatusDropdownProps {
  options: {
    label: string;
    code: string | number;
  }[];
  selectedItem: string | number;
  setSelectedItem: (val: string, code: string | number) => void;
}

const statusClassMap: Record<string, string> = {
  'On Track': 'on_track',
  'At Risk': 'at_risk',
  Completed: 'completed',
  Deferred: 'deferred',
  Cancelled: 'cancel',
  Inactive: 'inactive',
};

const iconMap: Record<string, string> = {
  'On Track': 'on_track',
  'At Risk': 'at_risk',
  Completed: 'completed',
  Deferred: 'deferred',
  Cancelled: 'cancel_archive',
  Inactive: 'cancel_archive',
};
const iconSizeMap: Record<string, number> = {
  'On Track': 16,
  'At Risk': 16,
  Completed: 16,
  Deferred: 18,
  Cancelled: 18,
  Inactive: 18,
};

export const StatusDropdown: React.FC<StatusDropdownProps> = ({
  options,
  selectedItem,
  setSelectedItem,
}) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  useClickOutside(dropdownRef, () => setShowDropdown(false));
  return (
    <div ref={dropdownRef} className={`dropdown_container ${styles.dropdown_container}`}>
      <div
        className={`dropdown_selected ${styles.dropdown_selected} ${styles[statusClassMap[selectedItem] ?? 'on_track']}`}
        onClick={() => setShowDropdown((prev) => !prev)}
      >
        <Icon
          name={iconMap[selectedItem] ?? 'on_track'}
          size={iconSizeMap[selectedItem] ?? 16}
          color="currentColor"
          className={styles.selectedIcon}
        />
        <span className={styles.selected_text}>{selectedItem}</span>
        <Icon
          name="dropdown_icon"
          size={13}
          className={`dropdown_icon ${styles.dropdown_icon} ${showDropdown ? styles.rotate : ''}`}
          color="currentColor"
        />
      </div>
      {/* Dropdown menu */}
      {showDropdown && (
        <div className={`${styles.status_menu}`}>
          {options?.map((menu) => (
            <div
              className={`dropdown_item ${styles.dropdown_item} ${
                menu?.label === selectedItem ? styles.dropdown_selected_item : ''
              }`}
              key={menu?.code}
              onClick={() => {
                setSelectedItem(menu?.label, menu?.code);
                setShowDropdown(false);
              }}
            >
              <span>{menu?.label}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
